import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileManagerService } from './file-manager.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [FileManagerService]
})
export class FileManagerModule {}
